const warehouseModule = {
    namespaced: true,
    persistent: true,
    state: {
        data: {}
    },
    mutations: {
        setWarehouseId(state, payload) {
            let userId = payload.userId;
            state.data[userId] = payload.warehouseId;
        },
        reset(state) {
            state.data = {}
        }
    },
    getters: {
        getWarehouseId: state => userId => {
            return state.data[userId] || null;
        }
    }
};

export default warehouseModule;
